import styled from "styled-components";

export const Container = styled.footer`
  width: 100%;
  height: 30px;
  display: flex;
  background-color: var(--color-black-0);
  box-shadow: var(--box-shadow);

  span {
    margin: 10px auto;
    color: var(--color-white-0);
    font-size: 12px;
  }
`;
